import { IconButton } from '@mui/material';
import AttachmentIcon from '@mui/icons-material/Attachment';
import addNotification from '../../utils/addNotification';
import { NotificationType } from '../../config';

const FileUploadButtonUI = ({ handleUploadFile }) => {
  return (
    <IconButton
      component="label"
      sx={{
        background: '#f59e0b',
        borderRadius: '0.5rem',
        color: 'white',
        '&:hover': {
          background: '#d97706',
        },
      }}
    >
      <AttachmentIcon />
      <input
        type="file"
        hidden
        multiple
        onChange={(e) => {
          handleUploadFile(Array.from(e.target.files));

          addNotification({
            content: 'Sikeres fájl hozzáadás!',
            type: NotificationType.SUCCESS,
          });
        }}
      />
    </IconButton>
  );
};

export default FileUploadButtonUI;
